import { H5 } from "@blueprintjs/core";
import React from "react";

const TITLE = "Next Course Recommendations by Department";

export function Title(): JSX.Element {
  return <H5 className={"recommendations-unit-content--title"}>{TITLE}</H5>;
}
